// Ensure global jQuery reference
$ = jQuery;

$(document).ready(function () {
    const width = document.body.clientWidth;

    // Mobile menu overlay. Opening locks the page behind it (position:fixed
    // via .menu-lock keeps the scroll offset, restored on close); X, Escape
    // and the burger close it; focus stays inside while open and returns to
    // the burger on close; the skills accordion resets to collapsed.
    const $menuOpen = $('#menuOpen');
    const $menuBox = $('.menuBox');
    let menuScrollY = 0;

    function mobileMenuIsOpen() {
        return $menuOpen.hasClass('opened');
    }

    function openMobileMenu() {
        menuScrollY = window.scrollY || 0;
        $menuOpen.addClass('opened').attr('aria-expanded', 'true');
        $('body').addClass('menu-lock').css('top', -menuScrollY + 'px');
        $menuBox.find('.m-menu-close').trigger('focus');
    }

    function closeMobileMenu(refocus) {
        if (!mobileMenuIsOpen()) {
            return;
        }
        $menuOpen.removeClass('opened').attr('aria-expanded', 'false');
        $('body').removeClass('menu-lock').css('top', '');
        window.scrollTo({ top: menuScrollY, left: 0, behavior: 'instant' });
        $menuBox
            .find('.skills-menu-trigger.active')
            .removeClass('active')
            .attr('aria-expanded', 'false')
            .closest('li')
            .removeClass('submenu-open');
        if (refocus) {
            $menuOpen.trigger('focus');
        }
    }

    $menuOpen.on('click', function () {
        if (mobileMenuIsOpen()) {
            closeMobileMenu(false);
        } else {
            openMobileMenu();
        }
    });

    $menuBox.on('click', '.m-menu-close', function () {
        closeMobileMenu(true);
    });

    $(document).on('keydown', function (e) {
        if (!mobileMenuIsOpen()) {
            return;
        }
        if (e.key === 'Escape') {
            closeMobileMenu(true);
            return;
        }
        // Keep Tab cycling inside the open menu.
        if (e.key === 'Tab') {
            const $focusables = $menuBox.find('a[href], button').filter(':visible');
            if (!$focusables.length) {
                return;
            }
            const first = $focusables[0];
            const last = $focusables[$focusables.length - 1];
            if (e.shiftKey && (document.activeElement === first || !$menuBox[0].contains(document.activeElement))) {
                last.focus();
                e.preventDefault();
            } else if (!e.shiftKey && document.activeElement === last) {
                first.focus();
                e.preventDefault();
            }
        }
    });

    // Leaving mobile widths must not keep the page locked.
    $(window).on('resize', function () {
        if (window.innerWidth >= 1081) {
            closeMobileMenu(false);
        }
    });

    // Language switcher row inside the mobile menu.
    $('.m-lang-toggle').on('click', function () {
        const expanded = !$(this).hasClass('active');
        $(this).toggleClass('active', expanded).attr('aria-expanded', expanded ? 'true' : 'false');
        $(this).closest('.m-lang').toggleClass('open', expanded);
    });

    // Mobile navigation dropdown
    if (width < 1081) {
        $('#mainMenu .menu-item-has-children > a').append('<span></span>');

        $('#mainMenu .menu-item-has-children span').on('click', function () {
            $(this).parent().next().slideToggle(300);
            $(this).toggleClass('active');
            return false;
        });

        // Remove empty <p> tags
        $('p').each(function () {
            const $this = $(this);
            if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
                $this.remove();
            }
        });

        $('.filter-target').on('click', function(e) {
            e.preventDefault();
            $('.sideBox').fadeIn().addClass('active');
            $('body').addClass('is_overflow');
        });

        $('.sideBox .overlay, .sideBox .close').on('click', function() {
            $('.sideBox').fadeOut().removeClass('active');
            $('body').removeClass('is_overflow');
        });
    }

    $('.boxes-tabs .tab').on('click', function() {
        var targetId = $(this).data('target');
        var $targetBox = $('#' + targetId);
        if ($targetBox.length) {
            $('html, body').animate({
                scrollTop: $targetBox.offset().top - 200
            }, 600);
            $('.boxes-tabs .tab').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.mini-cart-toggle').on('click', function(e) {
        e.preventDefault();
        $('.mini-cart-popup').fadeIn().addClass('active');
        $('body').addClass('is_overflow');
    });

    $('.for-search').on('click', function(e) {
        e.preventDefault();
        $('.search-popup').fadeIn().addClass('active');
        $('body').addClass('is_overflow');
    });

    $('.h-popup .overlay, .h-popup .popup-close').on('click', function() {
        $('.h-popup').fadeOut().removeClass('active');
        $('body').removeClass('is_overflow');
    });

    // Skills mega menu: dropdown panel under the header on desktop, an
    // accordion inside the mobile menu below 1081px. Markup comes from
    // duckrabbit_menu_pro_trigger() + tpl-parts/skills-megamenu.php.
    const $skillsTrigger = $('.skills-menu-trigger');
    const $skillsPanel = $('#skillsMegamenu');

    if (width < 1081) {
        // Accordion per the mobile Figma frames: the trigger turns blue and
        // the two-column skills grid expands below it (CSS: .submenu-open).
        $skillsTrigger.attr('aria-controls', 'skillsSubmenu');
        $skillsTrigger.on('click', function () {
            const expanded = !$(this).hasClass('active');
            $(this).toggleClass('active', expanded).attr('aria-expanded', expanded ? 'true' : 'false');
            $(this).closest('li').toggleClass('submenu-open', expanded);
        });
    } else if ($skillsTrigger.length && $skillsPanel.length) {
        const closeSkillsMenu = function (refocus) {
            if (!$skillsPanel.hasClass('is-open')) {
                return;
            }
            $skillsPanel.removeClass('is-open');
            $skillsTrigger.attr('aria-expanded', 'false');
            if (refocus) {
                $skillsTrigger.trigger('focus');
            }
        };

        $skillsTrigger.on('click', function () {
            if ($skillsPanel.hasClass('is-open')) {
                closeSkillsMenu(false);
            } else {
                $skillsPanel.addClass('is-open');
                $skillsTrigger.attr('aria-expanded', 'true');
            }
        });

        // Close on click outside, on Esc (returning focus to the trigger),
        // and when another header panel opens.
        $(document).on('click', function (e) {
            if (!$(e.target).closest('#skillsMegamenu, .skills-menu-trigger').length) {
                closeSkillsMenu(false);
            }
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                closeSkillsMenu(true);
            }
        });

        $('.menu-age, .mini-cart-toggle, .for-search').on('click', function () {
            closeSkillsMenu(false);
        });
    }

    $('.menu-age').on('click', function(e) {
        e.preventDefault();
        $('.menu-age-panel').fadeIn().addClass('active');
        $('body').addClass('is_overflow');
    });

    $('.menu-age-panel .overlay, .menu-age-panel .close').on('click', function() {
        $('.menu-age-panel').fadeOut().removeClass('active');
        $('body').removeClass('is_overflow');
    });

    $('.attr-filter .toggle-title').on('click', function() {
        var $title = $(this);
        var $list = $title.next('.side-filter');
        $list.slideToggle();
        $title.toggleClass('active');
    });

    initQuantityInput();
    $('body').on('click', '.minus', function (e) {
        var val = parseInt($(this).parent().find('input').val());
        if (val !== 0) {
            $(this).parent().find('input').val(val - 1).change();
        }
    });
    $('body').on('click', '.plus', function (e) {
        var val = parseInt($(this).parent().find('input').val());
        $(this).parent().find('input').val(val + 1).change();
    });
    $(document.body).on('updated_cart_totals', function () {
        initQuantityInput();
    });

    function initQuantityInput() {
        $("form .quantity").each(function () {
            var $quantity = $(this);
            if (!$quantity.children('.minus').length) {
                $quantity.prepend('<div class="minus qControls">-</div>');
            }
            if (!$quantity.children('.plus').length) {
                $quantity.append('<div class="plus qControls">+</div>');
            }
        });
    }

    $('.woocommerce-cart').on('change', 'input.qty', function(){
        $("[name='update_cart']").removeAttr('disabled').click();
    });

    $('.postsSlider').each(function () {
        let slider_holder = $(this),
            swiper_instance = slider_holder.find('.swiper'),
            prev = slider_holder.find('.swiper-button-prev'),
            next = slider_holder.find('.swiper-button-next');

        let postsSlider = new Swiper(swiper_instance[0], {
            spaceBetween: 20,
            slidesPerView: 1,
            watchOverflow: true,
            autoHeight: true,
            navigation: {
                nextEl: next[0],
                prevEl: prev[0]
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1081: {
                    slidesPerView: 3,
                }
            }
        });
    });

    /*// Swiper sliders initialization
    $('.slider').each(function () {
        const slider = $(this);
        const swiperEl = slider.find('.swiper')[0];
        const prevEl = slider.find('.swiper-prev')[0];
        const nextEl = slider.find('.swiper-next')[0];
        const paginationEl = slider.find('.swiper-pagination')[0];

        new Swiper(swiperEl, {
            spaceBetween: 20,
            slidesPerView: 1,
            watchOverflow: true,
            autoHeight: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true
            },
            grabCursor: true,
            effect: 'creative',
            creativeEffect: {
                prev: {
                    translate: ['-20%', 0, -1],
                },
                next: {
                    translate: ['100%', 0, 0],
                },
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                }
            }
        });
    });*/

    // Custom select styling
    /*if ($('select').length > 0) {
        $('select').selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            arrowButtonMarkup: '<span class="select_arrow"></span>'
        });

        // Optional: reset first option for CF7 selects
        // $('select.wpcf7-form-control').each(function () {
        //     $(this).find('option').first().val('');
        // });
    }*/

    // Contact Form 7 - remove validation tip on click
    $(document).on('click', '.wpcf7-not-valid-tip', function () {
        $(this).prev().trigger('focus');
        $(this).fadeOut(500, function () {
            $(this).remove();
        });
    });

    // Make iframe responsive (content only; skip service iframes appended to <body>, e.g. Cookiebot)
    $('#main iframe').wrap("<div class='fullframe'></div>");

    // Window resize (empty, reserved for future logic)
    $(window).on('resize', function () {
        // Add responsive handling if needed
    });
});